var path = 'components/channels/tooltips/channelsNetworksNames.html';
var html = "<div class=tooltip-list> <div ng-repeat=\"name in ch._networksNames() | orderBy track by $index\" ng-bind=name /> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;